module.exports = __webpack_public_path__ + "img/normal_multiplier_2.e97ccbc3.png";